import { useQuery } from "react-query";
import { useContext } from "react";
import { AuthContext } from "../../Context/AuthContext";

const useConcernStats = () => {
  const { token } = useContext(AuthContext);

  const fetchConcernStats = async () => {
    const response = await fetch(
      `${process.env.REACT_APP_SERVER_URL}/raise/concerns/stats`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      }
    );

    if (!response.ok) {
      throw new Error("Failed to fetch concern stats");
    }

    return await response.json();
  };

  const {
    data: concernStats,
    isLoading,
    isError,
  } = useQuery("concernStats", fetchConcernStats);

  return {
    concernStats,
    loading: isLoading,
    error: isError,
  };
};

export default useConcernStats;
